import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-24 md:bottom-6 right-4 md:right-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${CONTACT.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="group w-13 h-13 md:w-14 md:h-14 rounded-full bg-[#16A34A] hover:bg-[#128a3a] shadow-[0_10px_30px_rgba(22,163,74,0.35)] flex items-center justify-center mm-transition"
        style={{ width: 56, height: 56 }}
      >
        <MessageCircle className="h-6 w-6 text-white" strokeWidth={2} />
      </a>
      <a
        href={`tel:+${CONTACT.phoneDigits}`}
        data-testid="floating-call"
        aria-label="Call Money Mart"
        className="w-14 h-14 rounded-full bg-[#0F2D52] hover:bg-[#0a1f38] shadow-[0_10px_30px_rgba(15,45,82,0.35)] flex items-center justify-center mm-transition"
      >
        <Phone className="h-5 w-5 text-white" strokeWidth={2} />
      </a>
    </div>
  );
}
